import { render } from "./overviewDialog.vue?vue&type=template&id=10c6a342&scoped=true"
import script from "./overviewDialog.vue?vue&type=script&lang=js"
export * from "./overviewDialog.vue?vue&type=script&lang=js"

import "./overviewDialog.vue?vue&type=style&index=0&id=10c6a342&lang=scss"
import "./overviewDialog.vue?vue&type=style&index=1&id=10c6a342&scoped=true&lang=scss"

import exportComponent from "I:\\2019projectALL\\PHP\\phpstudy\\WWW\\Composer\\2025\\appoinment\\appoinmentWebV3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10c6a342"]])

export default __exports__